import { Action } from 'redux';
import { OnRequestRuleFilters, OnRequestRuleModel } from '../../../api/pricing/pricing.types';
import { Page } from '../../../api/api.types';

export const GET_ON_REQUEST_RULE_LIST = 'GET_ONE_REQUEST_RULE_LIST';
export const GET_ON_REQUEST_RULE = 'GET_ONE_REQUEST_RULE';
export const PUT_ON_REQUEST_RULE = 'PUT_ON_REQUEST_RULE';
export const POST_ON_REQUEST_RULE = 'POST_ON_REQUEST_RULE';
export const DELETE_ON_REQUEST_RULE = 'DELETE_ON_REQUEST_RULE';
export const UPDATE_ON_REQUEST_RULE_FILTERS = 'UPDATE_ON_REQUEST_RULE';

export interface OnRequestRuleState {
  onRequestRules: OnRequestRuleModel[] | [];
  selectedOnRequestRule: OnRequestRuleModel | null;
  postSuccess: boolean | null;
  lastFetch: number | null;
  totalPages: number;
  totalElements: number;
  filters: OnRequestRuleFilters | null;
}

export interface GetOnRequestRuleListAction extends Action {
  type: typeof GET_ON_REQUEST_RULE_LIST;
  payload: {
    page: Page<OnRequestRuleModel>;
  };
}

export interface GetOneOnRequestRuleAction extends Action {
  type: typeof GET_ON_REQUEST_RULE;
  payload: {
    selectedOnRequestRule: OnRequestRuleModel | null;
  };
}

export interface PutOnRequestRuleFilter extends Action {
  type: typeof PUT_ON_REQUEST_RULE;
  payload: {
    selectedOnRequestRule: OnRequestRuleModel;
  };
}

export interface PostOnRequestRuleAction extends Action {
  type: typeof POST_ON_REQUEST_RULE;
  payload: {
    newOnRequestRule: OnRequestRuleModel;
    success: boolean;
  };
}

export interface DeleteOnRequestRuleAction extends Action {
  type: typeof DELETE_ON_REQUEST_RULE;
  payload: {
    success: boolean;
  };
}

export interface UpdateOnRequestRuleAction extends Action {
  type: typeof UPDATE_ON_REQUEST_RULE_FILTERS;
  payload: {
    filters: OnRequestRuleFilters;
  };
}

export type OnRequestRuleActionTypes = GetOnRequestRuleListAction | GetOneOnRequestRuleAction | PutOnRequestRuleFilter | PostOnRequestRuleAction | DeleteOnRequestRuleAction | UpdateOnRequestRuleAction;
